import React from 'react'
import NavbarCommon from '../components/NavbarCommon'
import Jumbroton from '../components/Jumbroton'
import CompanyTrust from '../components/CompanyTrust'
import WhyChooseFAQ from '../components/WhyChooseFAQ'
import Footer from '../components/Footer'
import Testimoni from '../components/Testimoni'
import CallToAction from '../components/CallToAction'

function Home() {
  return (
    <div >
      <NavbarCommon />
      <Jumbroton />
      <CompanyTrust />
      <WhyChooseFAQ />
      <Testimoni />
      <CallToAction />
      <Footer />
    </div>
  )
}

export default Home